import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImageModel from '../../../shared/components/ImageModal/ImageModel';
import ImageSlider from '../../../shared/components/ImageSlider/ImageSlider';
import ZoomIcon from "../../../shared/icons/icon-zoom-icon.svg"
import ImageBox from '../ImageBox/ImageBox';
import MediaQueryListener from '../../helpers/MediaQueryListener';

class PhotoCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
      currentIndex: 0,
      visibleImages: 5,
      isMobile: window.matchMedia("(max-width: 640px)").matches,
    };
    this.handlePrev = this.handlePrev.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.getVisibleImages = this.getVisibleImages.bind(this);
    this.handleThumbnailClick = this.handleThumbnailClick.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.mq = new MediaQueryListener(() => this.forceUpdate());
  }




  componentDidMount() {
    this.mediaQuery = window.matchMedia("(max-width: 640px)");
    this.setState({ isMobile: this.mediaQuery.matches, visibleImages: this.mediaQuery.matches ? 4 : 5 });
    this.mediaQuery.addEventListener('change', this.handleResize);
  }
  componentWillUnmount() {
    this.mediaQuery.removeEventListener('change', this.handleResize);
  }
  handleResize(event) {
    this.setState({ isMobile: event.matches, visibleImages: event.matches ? 4 : 5 });
  };

  componentDidUpdate(prevProps) {

    const { carouselImages } = this.props;
    if (carouselImages !== prevProps.carouselImages) {
      this.setState({
        activeIndex: 0,
        currentIndex: 0,
      });
    }
  }

  handlePrev() {

    this.setState((prevState) => {
     const {activeIndex,currentIndex}=prevState;
      if (activeIndex > 0) {
        const newActiveIndex = activeIndex - 1;
        const newCurrentIndex =
          newActiveIndex < currentIndex
            ? currentIndex - 1
            : currentIndex;
        return {
          activeIndex: newActiveIndex,
          currentIndex: newCurrentIndex,
        };
      }
    });
  };
  handleNext() {

    const { carouselImages } = this.props;
    this.setState((prevState) => {
      const {activeIndex,currentIndex}=prevState;
      if (activeIndex < carouselImages.length - 1) {
        const newActiveIndex = activeIndex + 1;
        const newCurrentIndex =
          newActiveIndex >= currentIndex + this.state.visibleImages
            ? currentIndex + 1
            : currentIndex;
        return {
          activeIndex: newActiveIndex,
          currentIndex: newCurrentIndex,
        };
      }
    });
  };

  handleThumbnailClick(index) {
    const {currentIndex,visibleImages,}=this.state
    const newActiveIndex = index;
    const newCurrentIndex =
      newActiveIndex >= currentIndex + visibleImages
        ? newActiveIndex - visibleImages + 1
        : newActiveIndex < currentIndex
          ? newActiveIndex
          : currentIndex;
    this.setState({
      activeIndex: newActiveIndex,
      currentIndex: newCurrentIndex,
    });
  };

  getVisibleImages() {
    const { carouselImages } = this.props;
    return carouselImages.slice(
      this.state.currentIndex,
      this.state.currentIndex + this.state.visibleImages
    );
  };




  render() {
    const { carouselImages } = this.props;
    if ((carouselImages && carouselImages.length === 0) || !carouselImages) {
      return null;
    }
    const { activeIndex, currentIndex, visibleImages } = this.state;
    const totalImages = carouselImages.length;
    const isArrowVisible = carouselImages && carouselImages.length > visibleImages;

    return (
      <div className="photo-carousel__carousel">
        <ImageModel
          styleFlag='image'
          imgUrl={carouselImages[activeIndex] || {}}
          imgArray={carouselImages}
          handleNext={this.handleNext}
          handlePrev={this.handlePrev}
          getVisibleImages={this.getVisibleImages}
          activeIndex={activeIndex}
          currentIndex={currentIndex}
          visibleImages={this.state.visibleImages}
          handleThumbnailClick={this.handleThumbnailClick}
          totalImages={totalImages}
          isArrowVisible={isArrowVisible}
        >
          <div className='image-zoom-in-icon'>
            <ZoomIcon />
          </div>
          <ImageBox images={carouselImages} activeImage={activeIndex} handleNext={this.handleNext}
            handlePrev={this.handlePrev} />
        </ImageModel>
        <span className='image-modal__current-step'>
          {activeIndex + 1} of {totalImages}
        </span>
        <ImageSlider images={carouselImages}
          handleNext={this.handleNext}
          handlePrev={this.handlePrev}
          getVisibleImages={this.getVisibleImages}
          activeIndex={activeIndex}
          currentIndex={currentIndex}
          visibleImages={this.state.visibleImages}
          handleThumbnailClick={this.handleThumbnailClick}
          totalImages={totalImages}
          isArrowVisible={isArrowVisible}
          cssStyle={"hide-class"}
        />
      </div>
    );
  }
}

PhotoCarousel.propTypes = {
  carouselImages: PropTypes.arrayOf(
    PropTypes.shape({}),
  ).isRequired,
};

export default PhotoCarousel;

